import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";

export interface UserOption {
    id: string;
    name?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
}

export const userLabel = (user: UserOption) => {
    const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ");
    return fullName || user.name || user.email || user.id;
};

export const UserSelect = ({ value, onChange, label, disabled = false, size }: {
    value: string;
    onChange: (id: string) => void;
    label: string;
    disabled?: boolean;
    size?: "small" | "medium";
}) => {
    const users = useQuery({
        queryKey: ["fluss", "metadata", "users"],
        queryFn: async () => {
            const response = await new RecordManagement<UserOption>("sys_users").orderBy("email", "asc").run();
            return response.data;
        },
        enabled: !disabled || Boolean(value),
    });

    return <Autocomplete
        fullWidth
        size={size}
        disabled={disabled}
        options={users.data || []}
        getOptionLabel={userLabel}
        isOptionEqualToValue={(option, current) => option.id === current.id}
        value={users.data?.find((candidate) => candidate.id === value) || null}
        onChange={(_, selected) => onChange(selected?.id || "")}
        renderInput={(params) => <TextField {...params} label={label} />}
    />;
};

export default UserSelect;
